import React from "react";
import { NewDynamicTab } from "../../../components/Page";
import { JvvnlOverviewMetric } from "../../../config/DefaultDates";
import { JvvnlTitle, TabSwitcher } from "../Jvnnl_Dashboard";
import JvvnlGlobalSearch from "../../../components/Search/Jvvnl/GlobalSearch";
import LoadMapIndex from "./LoadMapIndex";

const LoadMap = () => {
  return (
    <NewDynamicTab
      headerPrefixComponent={<TabSwitcher />}
      rightPrefixComponent={<JvvnlGlobalSearch />}
      defaultDates={JvvnlOverviewMetric}
      header="Load Map"
      showTabs={false}
      showDates={false}
      middleComponent={<JvvnlTitle />}
      tabs={{
        Metric: <LoadMapIndex />,
      }}
    />
  );
};

export default LoadMap;
